<template>
  <figure :class="['msg cust']" role="group">
    <div class="upload-error">
      <svg class="upload-error__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
      </svg>
      <span class="upload-error__filename">{{ chat.message_rich.filename }}</span>
      <span class="upload-error__message">{{ chat.message_rich.message }}</span>
    </div>
    <figure-caption :chat="chat" :operator-name="operatorName" />
  </figure>
</template>

<script>
import FigureCaption from 'Chats/FigureCaption'

export default {
  components: { FigureCaption },
  props: {
    chat: { type: Object, required: true },
    operatorName: { type: String, required: true }
  }
}
</script>
